/** The PI approval stage in plain words — who has it now. */
export function piStageLabel(st: string): string {
  switch (st) {
    case 'Pending CEO Approval': return 'PI · awaiting CEO approval';
    case 'Approved by CEO': return 'PI approved by CEO · with Accounts';
    case 'On Hold - Accounts': return 'PI on hold · Accounts';
    case 'Approved': return 'PI approved by Accounts · awaiting payment';
    case 'Rejected by CEO': return 'PI rejected by CEO';
    case 'Rejected by Accounts': return 'PI rejected by Accounts';
    default: return st;
  }
}
